export default [
  {
    id: 1,
    value: 'JANUARY',
    name: 'Janeiro',
  },
  {
    id: 2,
    value: 'FEBUARY',
    name: 'Fevereiro',
  },
  {
    id: 3,
    value: 'MARCH',
    name: 'Março',
  },
  {
    id: 4,
    value: 'APRIL',
    name: 'Abril',
  },
  {
    id: 5,
    value: 'MAY',
    name: 'Maio',
  },
  {
    id: 6,
    value: 'JUNE',
    name: 'Junho',
  },
  {
    id: 7,
    value: 'JULY',
    name: 'Julho',
  },
  {
    id: 8,
    value: 'AUGUST',
    name: 'Agosto',
  },
  {
    id: 9,
    value: 'SEPTEMBER',
    name: 'Setembro',
  },
  {
    id: 10,
    value: 'OCTOBER',
    name: 'Outubro',
  },
  {
    id: 11,
    value: 'NOVEMBER',
    name: 'Novembro',
  },
  {
    id: 12,
    value: 'DECEMBER',
    name: 'Dezembro',
  },
];
